import { useState } from "react";
import { useAlert } from '../../providers/AlertProvider';
import { use_upload_pdf } from "../../api/service";
import logger from "../../utils/logger";
import '../css/UploadPdf.css'; // Ensure this path matches your directory structure

export const UploadPdf = ({ serviceUuid, type, show }) => {
    const { showAlert } = useAlert();

    const [file, setFile] = useState(null);
    const [statusMessage, setStatusMessage] = useState("");

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleFileUpload = async () => {
        if (!file) {
            setStatusMessage("Please select a file to upload.");
            return;
        }

        logger.log("file added for: ", serviceUuid, type);

        // Call the upload function
        const response = await use_upload_pdf(file, serviceUuid, type);

        showAlert({
            message: `${response.message}`,
            type: `${response.status === 200 || response.status === 201 ? 'success' : 'danger'}`,
            buttons: [{ 
                label: 'OK',
                type: `${response.status === 200 || response.status === 201 ? 'success' : 'danger'}`,
            }
            ],
        });

        show(false);
    };

    const handleCancelUpload = () => {
        show(false);
    }

    return (
        <div className="upload-pdf-container">
            <div className="upload-pdf-form">
                <h2>Upload PDF for {type[0].toUpperCase() + type.slice(1)}</h2>
                <input
                    type="file"
                    accept="application/pdf"
                    onChange={handleFileChange}
                    className="upload-pdf-input"
                />
                <div style={{ flexDirection: 'row', display: 'flex', gap: 10,  justifyContent: 'center' }}>
                    <button
                        onClick={handleFileUpload}
                        className="upload-pdf-button"
                    >
                        Upload PDF
                    </button>
                    <button
                        onClick={handleCancelUpload}
                        className="cancel-pdf-button"
                    >
                        Cancel
                    </button>
                </div>
            </div>
            {statusMessage && (
                <div className="status-message">
                    {statusMessage}
                </div>
            )}
        </div>
    );
};
